// extracted by mini-css-extract-plugin
export default {"root":"ListGroupRow-root-e6dfab7e82b1df7ede9f4123dbd578a5"};